export { CenterPage } from './CenterPage'
